import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  config : MatSnackBarConfig;

  constructor(private snack : MatSnackBar) { 
  	this.config = {
  		duration : 18000,
  		verticalPosition : 'top',
  		horizontalPosition : 'right',
  		panelClass: ['snack-offset']
  	}
  }

  success(msg : string){
  	this.config['panelClass']= 'success-message';
  	this.snack.open(msg, 'Close', this.config);
  }

  error(msg : string){
  	this.config['panelClass']= 'error-message';
  	this.snack.open(msg, 'Close', this.config);
  }

}
